// extracted by mini-css-extract-plugin
export default {"wcLogo":"Navigation_wcLogo__LpRLy","navigation":"Navigation_navigation__Ain1S","navLink":"Navigation_navLink__313Er"};